<template>
  <div class="vKeyboard-container" v-if="showOrHide">
    <div class="pickup-tickets-wrapper vkey-wrapper">
      <button class="closeBtnKeyboard" v-on:click="callClose()">&times;</button>
     <div class="virtual-keyboard-component">
      <Keyboard
        :input="inputValue"
        @onChange="onChangeInput"
        :inputName="inputName"
        @onKeyPress="onKeyPress"
        :keyBoardType="keyType"
      />
    </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import SimpleKeyboard from "@/components/UIElements/SimpleKeyboard";
import { mapState, mapGetters, mapActions } from "vuex";
import { generateRandomCode } from "@/helper/collection";

export default {
  components: {
    Keyboard: SimpleKeyboard
  },
  props: {
    onClickHandler: { type: Function },
    onChangeEvent: { type: Function },
    onKeyEnter: { type: Function },
    showOrHide: {type:Boolean, default: true},
    inputName: {type: String},
    initialValue: {type: String, default: ''},
    keyBoardType: {type: String, default: 'Default'},
  },
  data() {
    return {
      ShowVirtualKeyBoard: false,
      InputString: '',
      selectedEle: null
    };
  },
  computed: {
    keyType() {
      return this.keyBoardType
    },
    inputValue() {
        return this.initialValue;
    }
  },
  beforeMount() {
  },
  methods: {
    generateRandomCode,
    onKeyPress(button) {
      console.log(button);
      if (button == "{enter}") {
        this.$emit("onKeyEnter", button);
      }
    },
    onChangeInput(event) {
        this.InputString = event
        this.$emit("changeKeyboardInput", this.InputString);
        this.$emit("onChangeEvent", this.InputString);
    },
    callClose: function() {
      this.$emit("onClickClose");
    },
  }
};
</script>
<style>
.virtual-keyboard-component {
  width: 90%;
  height: auto;
  margin: auto;
}

.closeBtnKeyboard {
    width: 45px;
    border: none;
    height: 35px;
    position: absolute;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    line-height: 0;
    font-size: 50px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    background-color: transparent;
    top: 4px !important;
    right: 4px !important;
    color: #6d6767;
    justify-content: center;
}

.vkey-wrapper {
  border-radius: 15px 15px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
 


// WEBPACK FOOTER //
// src/components/Partials/Vkeyboard.vue